import React, { useState, useEffect } from "react";
import l from "components/util/l";
import { useGet } from "seed/api";
import { useQuery } from "seed/gql";
import { Loading } from "seed/helpers";
import { preprocessContent } from "components/brief/util/content";
import RevisionForm from "components/brief/reviewer/revision/RevisionForm";
import EmptyPlaceholder from "components/brief/util/helpers/EmptyPlaceholder";

function Revision({
  flow,
  revision = null,
  revisionId,
  currentAuthor = "",
  currentMainTab = 0,
  isDeveloper = false,
  hideMainTabs = false,
  allowComments = true,
  showAdditionalCommentButton = false,
  selectedProposalIndex = 0,
  initialProposals = null,
  extraActions = null,
  onPublishedRevision = () => {},
  onClickEditProposal = null,
  onClickRegenerate = () => {},
  isRegenerating = false,
  onCreatedDevRevision = () => {},
}) {

  const requestRevision = useGet("/flows/get_last_revision", { flow_id: flow.id }, { skip: !!revision });
  const [revisionProposals, setRevisionProposals] = useState(initialProposals || []);
  const loadedRevision = revision || requestRevision.data?.revision;
  const currentRevisionId = revisionId || loadedRevision?.id;
  const revisionContent = preprocessContent({ ...(loadedRevision || {}), proposals: revisionProposals }) || {};

  const reqProposals = useQuery(`{
    flowRevisions {
      id
      name
      proposal
      prototype
      context
      solution
      status
    }
  }`, `version.id=${currentRevisionId}`, {
    onCompleted: (data) => setRevisionProposals((data.flowRevisions || []).map(toEditable)),
  });


  useEffect(() => {
    if (initialProposals) {
      setRevisionProposals(initialProposals);
      return;
    }
  }, [flow?.id, currentRevisionId, initialProposals]); // eslint-disable-line react-hooks/exhaustive-deps

  if ((!revision && requestRevision.loading) || reqProposals.loading)
    return <Loading />;

  if (!revision && requestRevision.error)
    return <div className="p-3 text-danger">
      {l("Error al obtener los datos.%PA371")}
    </div>;

  const revisionName = loadedRevision?.name || "";
  const revisionDate = loadedRevision?.createdAt || null;
  const revisionProposalList = revisionContent.proposals || [];
  const proposalIndex = revisionProposalList[selectedProposalIndex] ? selectedProposalIndex : 0;
  const selectedProposal = revisionProposalList[proposalIndex];

  if (selectedProposal == null) {
    return (
      <EmptyPlaceholder
        mainIconClass="fas fa-file-contract"
        title={l("No hay revisión disponible%PA577")}
        description={l("No hay una revisión válida para mostrar.%PA578")}
      />
    );
  }

return (
    <RevisionForm
      flow={flow}
      revisionId={currentRevisionId}
      revisionName={revisionName}
      revisionDate={revisionDate}
      currentAuthor={currentAuthor}
      currentMainTab={hideMainTabs ? 2 : currentMainTab}
      isDeveloper={isDeveloper}
      content={revisionContent}
      selectedProposalIndex={proposalIndex}
      onUpdate={requestRevision.refetch}
      onPublishedRevision={onPublishedRevision}
      allowComments={allowComments}
      showAdditionalCommentButton={showAdditionalCommentButton}
      onClickEditProposal={onClickEditProposal}
      onClickRegenerate={onClickRegenerate}
      isRegenerating={isRegenerating}
      onCreatedDevRevision={onCreatedDevRevision}
      extraActions={extraActions}
    />
  );

}

const toEditable = (proposal) => ({
  id: proposal.id,
  name: proposal.name,
  status: proposal.status,
  context: proposal.context || {},
  prototype: proposal.prototype || {},
  solution: proposal.solution || {},
  type: proposal.proposal?.type || "major",
  reference: proposal.proposal?.reference || null,
  content: proposal.proposal?.content || [],
  additional_comments: proposal.proposal?.additional_comments || "",
});

export default Revision;
